import { ErrorHandler, NgModule } from '@angular/core';

import { CerModule } from 'src/cer/cer.module';

import { CerAppApplicationInsightsService } from './cer-app-application-insights/cer-app-application-insights.service';
import { CerAppApplicationInsightsErrorHandler } from './cer-app-application-insights/cer-app-application-insights-error.service';

import { CerAppChatComponent } from './cer-app-chat/cer-app-chat.component';
import { CerAppFileViewerTabComponent } from './cer-app-file-viewer-tab/cer-app-file-viewer-tab.component';

import { CerAppLayoutMainRouterOutletComponent } from './cer-app-layout/cer-app-layout-main-router-outlet/cer-app-layout-main-router-outlet.component';
import { CerAppLayoutComponent } from './cer-app-layout/cer-app-layout.component';
import { CerAppLayoutSideNavComponent } from './cer-app-layout/cer-app-layout-sidenav/cer-app-layout-sidenav.component';
import { CerAppLayoutRouteTitleComponent } from 'src/cer-app/cer-app-layout/cer-app-layout-route-title/cer-app-layout-route-title.component';
import { CerAppLayoutHelpAboutComponent } from './cer-app-layout/cer-app-layout-help-about/cer-app-layout-help-about.component';

import { CerAppRouteService } from './cer-app-route/cer-app-route.service';
import { CerAppStateService } from './cer-app-state/cer-app-state.service';

import { CerFormPanesComponent } from '@form/cer-form-panes/cer-form-panes.component';
import { CerFormDialogComponent } from '@form/cer-form-dialog/cer-form-dialog.component';

import { CerPromptService } from '@ui/cer-ui-prompt.service';
import { CerAuthorizePromptService } from 'src/cer-identity/cer-authorize-prompt-service';
import { AuthorizeGuard } from 'src/cer-identity/guards/authorize.guard';
import { Route } from '@angular/router';

var cerAppDeclarations = [
  CerAppChatComponent,
  CerAppFileViewerTabComponent,
  CerAppLayoutHelpAboutComponent,
  CerAppLayoutComponent,
  CerAppLayoutSideNavComponent,
  CerAppLayoutRouteTitleComponent,
  CerAppLayoutMainRouterOutletComponent,
  CerFormPanesComponent,
  CerFormDialogComponent
]

var cerAppImports = [
  CerModule
];

var cerAppProviders = [
  CerPromptService,
  CerAppRouteService,
  CerAuthorizePromptService,
  CerAppStateService,
  CerAppApplicationInsightsService,
  { provide: ErrorHandler, useClass: CerAppApplicationInsightsErrorHandler },
];


var cerAppExports = [].concat(cerAppDeclarations).concat(cerAppImports);

export const cerAppMainRoute: Route =
{
  path: '', component: CerAppLayoutComponent, canActivate: [AuthorizeGuard]
};


@NgModule({
  declarations: cerAppDeclarations,
  imports: cerAppImports,
  providers: cerAppProviders,
  exports: cerAppExports
})
export class CerAppModule { }
